{
  const wrapper = document.querySelector('.js-horizontal-scroll-wrapper');
  const row = document.querySelector('.js-horizontal-scroll-row');

  const isMobile = window.matchMedia('(max-width: 749px)').matches;

  if (!isMobile) {
    const lenis = new Lenis({
      wrapper,
      content: row,
      smoothWheel: true,
      syncTouch: true,
      orientation: 'horizontal',
      gestureOrientation: 'both',
      autoRaf: true,
    })

    wrapper.style.touchAction = 'pan-x';
    wrapper.style.overscrollBehaviorX = 'contain';
    wrapper.style.webkitOverflowScrolling = 'touch';

    let targetScrollX = 0;
    let maxScrollX = 0;

    wrapper.__lenis = lenis;

    lenis.on('scroll', ({ scroll, limit }) => {
      maxScrollX = limit || 0;
      targetScrollX = constrain(scroll, 0, maxScrollX);
    });

    if (wrapper.dataset.triggerInitScroll === 'true') {
      wrapper.scrollLeft = 10000;
      setTimeout(() => {
        lenis.scrollTo(0, {
          duration: 3,
        })
      }, 100)
    }
  }
}
